import { Theme } from '@mui/material/styles';
export const connectWalletCardStyles = (theme: Theme, isDark: boolean) => ({
  text: {
    textAlign: 'center',
    fontVariationSettings: "'wght' 400",
    py: 0
  },
  issuancePaperConnect: {
    height: 'auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    px: 0,
    [theme.breakpoints.up('lg')]: {
      px: 1.5
    },
    [theme.breakpoints.up('xl')]: {
      px: 5
    },
    background: 'none',
    boxShadow: 'none'
  },
  container: {
    m: 0,
    p: 0,
    [theme.breakpoints.up('lg')]: { maxWidth: 'none' }
  }
});
